import React, { useState, createRef } from 'react';
import { TextareaField, Iconsvg, DragAndDrop, UploadStatus, FormFieldErrorInfo, SegmentedControl, SegmentedControlItem, Multiselect } from '@wk/components-react16';

const TryBatch = ({ data }: any) => {
    const { tryNowdocumentText, setTryNowdocumentText, tryNowdocumentBatchList, setTryNowdocumentBatchList, tryNowFileList, setTryNowFileList, tryRunSelectedIndex, setTryRunSelectedIndex, validationsList, setValidationsList, setIsOpenRunBatch } = data;

    const storyContainer = createRef<any>();
    let id = 0;

    const handleSegmentChange = (event: any) => {
        setTryRunSelectedIndex(event);
        if (event == 0) {
            setTryNowFileList([]);
            resetDocumentBatchList();
        } else if (event == 1) {
            setTryNowdocumentText('');
            resetDocumentBatchList();
        } else {
            setIsOpenRunBatch(true);
            setTryNowFileList([]);
            setTryNowdocumentText('');
        }
    }

    const resetDocumentBatchList = () => {
        tryNowdocumentBatchList.forEach((item: any) => item.isSelected = false);
        setTryNowdocumentBatchList([...tryNowdocumentBatchList]);
    }

    const handleRemoveDoc = (id: any) => {
        tryNowdocumentBatchList.find((item: any) => item.id == id).isSelected = false;
        const newBatchDocument = [...tryNowdocumentBatchList];
        setTryNowdocumentBatchList(newBatchDocument);
    }

    const handleFilesChange = (event: any) => {
            const targetFiles = Array.isArray(event) ? event : Array.from(event.target.files);
            const newFileItems = targetFiles.map((file: File) => {
                const uiFile = {
                    id: _nextId(),
                    nativeFile: file,
                    label: file.name,
                    type: file.type,
                    progress: 100,
                };
                return {
                    ...uiFile,
                    status: 'completed',
                };
            });

        const newFileList: any = [];
        setTryNowFileList([...newFileItems, ...newFileList]);
        }

        const handleFileItemClick = (file: any) => {
            if (file.status !== 'uploading') {
                setTryNowFileList(tryNowFileList.filter((f: any) => f.id !== file.id));
                const nativeInput =
                    storyContainer.current.ownerDocument.querySelector(
                        'input[type="file"]'
                    ) as HTMLInputElement;
                nativeInput.value = '';
            }
        }

        const _nextId = () => {
            id += 1;
            return 'i-' + id;
        }

        const getErrors = (): Array<FormFieldErrorInfo> => {
            return tryNowFileList.filter((f: any) => f.errorMsg).map((f: any) => ({ label: f.errorMsg, labelId: f.id }));
        }

        const getErrorIds = () => {
            return getErrors().map((e: any) => e.labelId).join(',');
        }

        const getIconName = (file: any) => {
            if (file.type.includes('pdf')) {
                return 'file-pdf';
            } else if (file.type.includes('jpeg') || file.type.includes('png')) {
                return 'photo';
            } else {
                return 'file';
            }
        }

    return (
        <>
            <div className="custom-overflow-inherit">
                <Multiselect
                    items={validationsList}
                    pillLabel="Validation Rule selected"
                    placeholder="Choose Validation Rule"
                    size="small"
                    label="Select Validation Rule"></Multiselect>
            </div>
            <div className="cg-field-header" style={{ fontSize: '0.875rem' }}>
                <label className="cg-field-label">Select Information for Try Now
                    <div className="cg-field-required-indicator"><span aria-hidden="true">*</span></div>
                </label>
            </div>
            <div className='custom-segmented-control'>
                <SegmentedControl
                    selectedIndex={tryRunSelectedIndex}
                    controlMode={'controlled'}
                    onUserRequest={(event: any) => handleSegmentChange(event)}>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Text
                    </SegmentedControlItem>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Upload
                    </SegmentedControlItem>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Batch
                    </SegmentedControlItem>
                </SegmentedControl>
            </div>
            {tryRunSelectedIndex == 0 ? (
                <div className="mb-15 mt-5">
                    <TextareaField labelFor="textarea-id-11">
                        <textarea style={{ height: '10rem' }}
                            id="textarea-id-11" name="tryNowdocumentText"
                            placeholder="Document Text"
                            onChange={(event: any) => setTryNowdocumentText(event.target.value)}
                            value={tryNowdocumentText}
                        ></textarea>
                    </TextareaField>
                </div>
            ) : null}
            {tryRunSelectedIndex == 1 ? (
                <div className="mb-15 mt-5" ref={storyContainer} style={{ minHeight: '10rem' }}>
                    <DragAndDrop
                        acceptTypes=".xlsx,.docx,.json,.png,.jpg,.jpeg" size="medium"
                            onFilesChange={(event: any) => handleFilesChange(event)}>
                        <input
                            id="file-upload-001"
                            type="file"
                            name="file-upload"
                            multiple
                            accept=".xlsx,.docx,.json,.png,.jpg,.jpeg"
                            aria-describedby={getErrorIds()}
                            onChange={(event: any) => handleFilesChange(event)}
                            slot="dragAndDropInput"
                        />
                        {tryNowFileList.map((item: any, i: number) =>
                            <UploadStatus
                                key={i}
                                label={item.label}
                                status={item.status}
                                size={item.nativeFile.size}
                                progress={item.progress}
                                isCompact
                                onItemClick={() => handleFileItemClick(item)}
                                slot="dragAndDropListItem">
                                <Iconsvg name={getIconName(item)}></Iconsvg>
                            </UploadStatus>
                        )}
                    </DragAndDrop>
                    <div className='mt-5 wk-size-1 text-warning-emphasis'>Accepted formats: Excel, Word (DOCX), JSON, PNG, JPG/JPEG.</div>
                </div>
            ) : null}
            {tryRunSelectedIndex == 2 ? (
                <div className="mb-15 mt-5 custom-multiselect" style={{ minHeight: '10rem' }}>
                    {/* <Multiselect
                        items={tryNowdocumentBatchList}
                        pillLabel="Document selected"
                        placeholder="Choose Document"
                        size="small"
                        label="Select Batch Document"></Multiselect> */}
                    {tryNowdocumentBatchList.filter((item: any) => item.isSelected).length > 0 ? tryNowdocumentBatchList.filter((item: any) => item.isSelected).map((item: any, index: number) => (
                        item.isSelected && (
                            <span key={index} className='mb-5 mr-5 badge text-bg-light align-middle border'>
                                <span className='wk-size-1 wk-weight-400'>{item.name}</span>
                                <span className='ml-5 cursor-pointer align-middle wk-size-1' onClick={() => handleRemoveDoc(item.id)}>
                                    <Iconsvg name="close" color="red" size={12}></Iconsvg>
                                </span>
                            </span>
                        )
                    )) : (
                        <table className='center h-100'>
                            <tbody><tr>
                                <td>
                                    <h6 className="btn btn-light" onClick={() => handleSegmentChange(2)}>Selected batch documents.</h6>
                                </td>
                            </tr></tbody>
                        </table>
                    )}
                </div>
            ) : null}
        </>
    );
};

export default TryBatch;